import React from "react";

export default function TableLoading({
  size = 24,
  className = "text-foreground",
}) {
  return (
    <>
      <style>
        {`
          @keyframes msg-bounce {
            0%, 100% { transform: translateY(0); opacity: .6; }
            50% { transform: translateY(-6px); opacity: 1; }
          }
          .msg-dot {
            animation: msg-bounce 0.6s infinite ease-in-out;
            transform-origin: center;
          }
          .msg-dot:nth-child(1) { animation-delay: 0s; }
          .msg-dot:nth-child(2) { animation-delay: 0.1s; }
          .msg-dot:nth-child(3) { animation-delay: 0.2s; }
        `}
      </style>

      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
      >
        <circle className="msg-dot" cx="4" cy="12" r="2" fill="currentColor" />
        <circle className="msg-dot" cx="12" cy="12" r="2" fill="currentColor" />
        <circle className="msg-dot" cx="20" cy="12" r="2" fill="currentColor" />
      </svg>
    </>
  );
}
